import { render, staticRenderFns } from "./leftItem02.vue?vue&type=template&id=178c2468&scoped=true&"
import script from "./leftItem02.vue?vue&type=script&lang=js&"
export * from "./leftItem02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178c2468",
  null
  
)

export default component.exports